<template>
  <div id="centerLeft1">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span>
          <!--          <icon name="chart-bar" class="text-icon"></icon>-->
        </span>
        <div class="d-flex">
          <div class="box-title">
            <span class="fs-xl text mx-2"
              ><dv-decoration-11 style="width: 200px; height: 60px"
                >汇总数据</dv-decoration-11
              ></span
            >
          </div>
          <!--          <dv-decoration-3 class=" mt10" />-->
        </div>
      </div>
      <div class="d-flex jc-center">
        <!--        <CenterLeft1Chart />-->
      </div>
      <!-- 4个主要的数据 -->
      <div class="data-grid-0" v-if="this.screenType === 0">
        <div
          v-for="(item, index) in numberData1"
          :key="index"
          class="df aic jcc"
          style="flex-direction: column"
          @click="openDailogData(item)"
        >
          <div style="font-size: 28px; line-height: 34px">
            <countTo
              class="dv-digital-flop"
              :startVal="start"
              :endVal="item.number ? item.number : 0"
              :duration="3000"
              :decimals="item.decimals"
            ></countTo>
          </div>
          <div style="color: #c3cbde; line-height: 16px">
            {{ item.text }}
            <span
              v-if="
                item.text === '今日支出' ||
                item.text === '历史总支出' ||
                item.text === '历史总收入' ||
                item.text === '今日收入'
              "
              class="colorYellow"
              >(元)</span
            >
            <span v-else class="colorYellow">(次)</span>
          </div>
          <div style="height: 0; line-height: 20px">
            <p
              v-if="item.text === '历史总支出'"
              class="grey pointer"
              @click="openDailog(1)"
            >
              (应付:{{ data.gzSpending }}元)
            </p>
            <p
              v-if="item.text === '历史总收入'"
              class="grey pointer"
              @click="openDailog(0)"
            >
              (应收:{{ data.gzIncome }}元)
            </p>
            <p v-if="item.text === '历史总支出'" class="grey">
              (已付款未收货:{{ data.fkNoReceive }}元)
            </p>
          </div>
        </div>
      </div>

      <div v-else class="df">
        <div class="data-grid">
          <div
            v-for="(item, index) in numberData2"
            :key="index"
            class="df aic jcc"
            style="flex-direction: column"
          >
            <div style="font-size: 28px; line-height: 34px">
              <countTo
                class="dv-digital-flop"
                :startVal="start"
                :endVal="item.number ? item.number : 0"
                :duration="3000"
                :decimals="item.decimals"
              ></countTo>
            </div>
            <div style="color: #c3cbde; line-height: 16px">
              {{ item.text }}
              <span
                v-if="
                  item.text === '今日支出' ||
                  item.text === '商品制售成本总支出' ||
                  item.text === '历史总收入' ||
                  item.text === '今日收入'
                "
                class="colorYellow"
                >(元)</span
              >
              <span v-else class="colorYellow">(次)</span>
            </div>
            <div style="height: 0; line-height: 20px">
              <p
                v-if="item.text === '商品制售成本总支出'"
                class="grey pointer"
                @click="openDailog(1)"
              >
                (应付:{{ data.gzSpending }}元)
              </p>
              <p v-if="item.text === '商品制售成本总支出'" class="grey">
                (已付款未收货:{{ data.fkNoReceive }}元)
              </p>
              <p
                v-if="item.text === '历史总收入'"
                class="grey pointer"
                @click="openDailog(0)"
              >
                (应收:{{ data.gzIncome }}元)
              </p>
            </div>
          </div>
        </div>
        <div v-if="!time.startTime">
          <!--                <dv-decoration-9 style="width:200px;height:200px;position: absolute;bottom: 30px;left: 0;right: 0;margin: auto"> </dv-decoration-9>-->
          <div class="d-flex jc-center">
            <CenterLeft1Chart :data="data" />
          </div>
        </div>
        <div v-else class="bottom-data">
          <h1></h1>
          <h1></h1>
          <div class="item-box mt-2">
            <div class="d-flex">
              <countTo
                class="dv-digital-flop"
                :startVal="start"
                :endVal="totalIncome ? totalIncome : 0"
                :duration="3000"
                :decimals="2"
              ></countTo>
            </div>
            <p class="text" style="text-align: center">
              时段总收入
              <span class="colorYellow">(元)</span>
            </p>
          </div>

          <div class="item-box mt-2">
            <div class="d-flex">
              <div class="dv-digital-flop">
                {{ time.startTime.split(" ")[0] }}
              </div>
            </div>
            <p class="text" style="text-align: center">
              开始时间
              <span class="colorYellow"></span>
            </p>
          </div>

          <div class="item-box mt-2">
            <div class="d-flex">
              <countTo
                class="dv-digital-flop"
                :startVal="start"
                :endVal="spendingATotal ? spendingATotal : 0"
                :duration="3000"
                :decimals="2"
              ></countTo>
            </div>
            <p class="text" style="text-align: center">
              时段总支出
              <span class="colorYellow">(元)</span>
            </p>
          </div>
          <div class="item-box mt-2">
            <div class="d-flex">
              <div class="dv-digital-flop">
                {{ time.endTime.split(" ")[0] }}
              </div>
            </div>
            <p class="text" style="text-align: center">
              结束时间
              <span class="colorYellow"></span>
            </p>
          </div>
          <!--                    <div>-->
          <!--                        {{totalIncome}}-->
          <!--                    </div>-->
          <!--                    <div>-->
          <!--                        {{spendingATotal}}-->
          <!--                    </div>-->
        </div>
      </div>
    </div>
    <el-dialog
      :title="query.tag == 0 ? '应收详情' : '应付详情'"
      :visible.sync="dialogTableVisible"
    >
      <div class="df aic jcb">
        <el-switch
          v-model="query.type"
          active-text="经营费用"
          inactive-text="货品结算"
          :active-value="0"
          :inactive-value="1"
          @change="(value) => openDailog(query.tag, value)"
        >
        </el-switch>
        <span>
          共计
          <span style="color: #0081ff">{{
            query.tag == 0 ? data.gzIncome : data.gzSpending
          }}</span>
          元
        </span>
      </div>
      <el-table :data="gridData" v-loading="tableLoading">
        <template v-if="query.type == 0">
          <el-table-column
            property="name"
            label="类型"
            header-align="center"
            align="center"
            label-width="150"
          ></el-table-column>
          <el-table-column
            property="tallyTime"
            header-align="center"
            align="center"
            label="时间"
            label-width="150"
          ></el-table-column>
          <el-table-column
            property="money"
            header-align="center"
            align="center"
            label="金额(元)"
            label-width="150"
          ></el-table-column>
        </template>
        <template v-else>
          <el-table-column
            :property="
              query.tag ? 'consignerCompanyName' : 'consigneeCompanyName'
            "
            :label="query.tag ? '待收款公司' : '待付款公司'"
            align="center"
            label-width="150"
            header-align="center"
          ></el-table-column>
          <el-table-column
            :property="query.tag ? 'receiveTime' : 'shipTime'"
            :label="query.tag ? '收货时间' : '发货时间'"
            align="center"
            label-width="150"
            header-align="center"
          ></el-table-column>
          <!-- <el-table-column
            label="货品"
            label-width="150"
            header-align="center"
            align="center"
          >
            <template v-slot="scope">
              {{ JSON.parse(scope.row.gtinInfo).goodsName }}
            </template>
          </el-table-column> -->
          <el-table-column
            :property="query.tag ? 'receiptSn' : 'shippingSn'"
            :label="query.tag ? '收货单号' : '发货单号'"
            header-align="center"
            align="center"
            label-width="150"
          ></el-table-column>
          <el-table-column
            property="goodsTotalPrice"
            label="金额(元)"
            align="center"
            label-width="150"
            header-align="center"
          ></el-table-column>
        </template>
      </el-table>
      <div class="df aic" style="justify-content: flex-end; margin-top: 20px">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="query.limit"
          @current-change="pageChange"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <el-dialog :title="snedTitle" :visible.sync="showSend" width="80%">
      <div
        style="
          margin-bottom: 10px;
          text-align: left;
          display: block;
          overflow: auto;
        "
        v-if="!['今日发货次数', '今日收货次数'].includes(snedTitle)"
      >
        <el-date-picker
          v-model="value1"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="handleDateChange"
        >
        </el-date-picker>
      </div>
      <div>
        <el-table border :data="sendList" style="width: 100%" id="out-table">
          <el-table-column min-width="120" type="expand">
            <template slot-scope="props">
              <el-form
                label-position="left"
                inline
                class="demo-table-expand pl30 pr30"
              >
                <el-form-item label="商品重量">
                  <h5>
                    {{
                      props.row.goodsWeight
                        ? props.row.goodsWeight + "kg"
                        : "未填写"
                    }}
                  </h5>
                </el-form-item>
                <el-form-item label="单个重量">
                  <h5>
                    {{
                      props.row.goodsUnit
                        ? props.row.goodsUnit + "kg"
                        : "未填写"
                    }}
                  </h5>
                </el-form-item>
                <el-form-item label="货品总数">
                  <h5>
                    {{
                      props.row.goodsSum ? props.row.goodsSum + "件" : "未填写"
                    }}
                  </h5>
                </el-form-item>
                <el-form-item label="货品件数">
                  <h5>
                    {{
                      props.row.goodsNumber
                        ? props.row.goodsNumber + "件"
                        : "未填写"
                    }}
                  </h5>
                </el-form-item>
                <el-form-item label="货品总价">
                  <h5>
                    {{
                      props.row.goodsTotalPrice
                        ? props.row.goodsTotalPrice + "元"
                        : "未填写"
                    }}
                  </h5>
                </el-form-item>
                <div>
                  <el-form-item label="运输车辆">
                    <h5>
                      {{ props.row.carNumber ? props.row.carNumber : "未填写" }}
                    </h5>
                  </el-form-item>
                  <el-form-item label="发货人姓名">
                    <h5>{{ props.row.created_name }}</h5>
                  </el-form-item>
                </div>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column
            :prop="sendQuery.type ? 'receiptSn' : 'shippingSn'"
            min-width="120"
            :show-overflow-tooltip="true"
            :label="sendQuery.type ? '收货订单号' : '发货订单号'"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="goodsName"
            min-width="120"
            :show-overflow-tooltip="true"
            label="商品名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            min-width="120"
            :show-overflow-tooltip="true"
            label="状态"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.status === 'finished'" style="color: green"
                >已完成</span
              >
              <span v-if="scope.row.status === 'shipped'" style="color: orange"
                >已发货</span
              >
              <span v-if="scope.row.status === 'pending'" style="color: blue"
                >待发货</span
              >
              <span v-if="scope.row.status === 'invalid'" style="color: red"
                >已作废</span
              >
            </template>
          </el-table-column>
          <el-table-column
            :prop="sendQuery.type ? 'receiveTime' : 'shipTime'"
            min-width="100"
            :show-overflow-tooltip="true"
            :label="sendQuery.type ? '收货时间' : '发货时间'"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="gtin"
            min-width="120"
            :show-overflow-tooltip="true"
            label="商品品码"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="batchNumber"
            min-width="120"
            :show-overflow-tooltip="true"
            label="批次号"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="consignerCompanyName"
            min-width="160"
            :show-overflow-tooltip="true"
            label="收货公司"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="goodsTotalPrice"
            min-width="160"
            :show-overflow-tooltip="true"
            label="总价(元)"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="qualification"
            min-width="160"
            :show-overflow-tooltip="true"
            label="相关资证"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="showImage(scope.row)"
                class="general_bgc general_border cfff"
                >查看图片</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="realPics"
            min-width="160"
            :show-overflow-tooltip="true"
            label="发货实景"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="showImage1(scope.row)"
                class="general_bgc general_border cfff"
                >查看图片</el-button
              >
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="car_number"
            min-width="120"
            :show-overflow-tooltip="true"
            label="运输车辆"
            align="center"
          >
          </el-table-column> -->
          <!-- <el-table-column
            prop="created_name"
            min-width="160"
            :show-overflow-tooltip="true"
            label="发货人姓名"
            align="center"
          >
          </el-table-column> -->
        </el-table>
      </div>

      <div class="df aic jcc">
        <el-pagination
          background
          :page-size="sendQuery.limit"
          layout="total,prev, pager, next"
          :total="sendTotal"
          :current-page="sendQuery.page"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <el-dialog title="相关资证" :visible.sync="picDialogVisible" top="8vh">
      <div v-if="reportList.length > 0">
        <el-divider content-position="left">
          <el-tag>资证报告</el-tag>
        </el-divider>
        <el-row :gutter="10">
          <el-col :span="6" v-for="(item, index) in reportList" :key="index">
            <el-image
              style="height: 200px"
              :src="item"
              :preview-src-list="reportList"
              z-index="99999"
            ></el-image>
          </el-col>
        </el-row>
      </div>
      <div v-else>
        <span>暂无</span>
      </div>
    </el-dialog>
    <el-dialog title="发货实景" :visible.sync="picDialogVisible1" top="8vh">
      <div v-if="attachList.length > 0">
        <el-divider content-position="left">
          <el-tag type="success">发货实景</el-tag>
        </el-divider>
        <el-row :gutter="10">
          <el-col :span="6" v-for="(item, index) in attachList" :key="index">
            <el-image
              style="height: 200px"
              :src="item"
              :preview-src-list="attachList"
            ></el-image>
          </el-col>
        </el-row>
      </div>
      <div v-else>
        <span>暂无</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import countTo from "vue-count-to";
import CenterLeft1Chart from "../../../../components/centerLeft1Chart";
import api from "@/util/extra-api";
// import { createLogger } from "vuex";
import dayjs from "dayjs";

export default {
  components: {
    countTo,
    CenterLeft1Chart,
  },
  props: {
    data: {
      type: Object,
    },
    screenType: {
      type: Number,
    },
    time: {
      type: Object,
    },
    spendingATotal: {
      type: Number,
    },
    totalIncome: {
      type: Number,
    },
  },
  data() {
    return {
      numberData1: [
        {
          number: this.data.totalIncome,
          text: "历史总收入",
          decimals: 2,
        },
        {
          number: this.data.todayTotalIncome,
          text: "今日收入",
          decimals: 2,
        },
        {
          number: this.data.shipmentsCount,
          text: "全部发货次数",
          decimals: 0,
        },
        {
          number: this.data.todayShipmentsCount,
          text: "今日发货次数",
          decimals: 0,
        },

        {
          number: this.data.spendingATotal,
          text: "历史总支出",
          decimals: 2,
        },
        {
          number: this.data.todaySpendingATotal,
          text: "今日采购费用",
          decimals: 2,
        },
        {
          number: this.data.receiveCount,
          text: "全部收货次数",
          decimals: 0,
        },
        {
          number: this.data.todayReceiveCount,
          text: "今日收货次数",
          decimals: 0,
        },
      ],

      numberData2: [
        {
          number: this.data.totalIncome,
          text: "历史总收入",
          decimals: 2,
        },
        {
          number: this.data.todayTotalIncome,
          text: "今日收入",
          decimals: 2,
        },
        {
          number: this.data.spendingATotal,
          text: "商品制售成本总支出",
          decimals: 2,
        },
        {
          number: this.data.todaySpendingATotal,
          text: "今日支出",
          decimals: 2,
        },
      ],
      start: 0,
      query: {
        companyId: "",
        page: 1,
        limit: 10,
        type: 0,
        tag: 0,
      },
      dialogTableVisible: false,
      gridData: [],
      total: 0,
      tableLoading: false,
      sendQuery: {
        type: 0,
        page: 1,
        limit: 10,
      },
      sendList: [],
      sendTotal: 0,
      snedTitle: "",
      showSend: false,
      reportList: [],
      attachList: [],
      picDialogVisible: false,
      picDialogVisible1: false,
      value1: [],
    };
  },
  mounted() {
    this.query.companyId = localStorage.getItem("company_id");
  },
  methods: {
    handleDateChange(data) {
      console.log(data, "测试");

      this.value1 = data;

      this.currentChange(1);
    },
    showImage(item) {
      this.reportList = [];
      this.picDialogVisible = true;
      let temp = JSON.parse(item.qualification);
      for (var key in temp) {
        temp[key].map((m) => {
          this.reportList.push(m.picUrl);
        });
      }
    },
    showImage1(item) {
      this.attachList = [];
      this.picDialogVisible1 = true;
      let temp = JSON.parse(item.real_pics);
      temp.map((m) => {
        this.attachList.push(m.url);
      });
    },
    currentChange(page) {
      this.sendQuery.page = page;
      let startTime = this.value1 && this.value1.length ? this.value1[0] : "";
      let endTime = this.value1 && this.value1.length ? this.value1[1] : "";
      api
        .get("/v1/wx/companyScreen/shipDetailList", {
          ...this.sendQuery,
          companyId: this.query.companyId,
          startTime,
          endTime,
        })
        .then((res) => {
          if (res.code === 200) {
            // console.log(res.data);
            this.sendList = res.data;
            this.sendTotal = res.total;
          }
        });
    },
    openDailogData(item) {
      if (
        [
          "全部发货次数",
          "全部收货次数",
          "今日发货次数",
          "今日收货次数",
        ].includes(item.text)
      ) {
        let flag = ["全部发货次数", "今日发货次数"].includes(item.text);
        let startTime = "";
        let endTime = "";
        if (["今日收货次数", "今日发货次数"].includes(item.text)) {
          startTime = dayjs().startOf("date").format("YYYY-MM-DD HH:mm:ss");
          endTime = dayjs().endOf("date").format("YYYY-MM-DD HH:mm:ss");
        }
        this.value1 = null;
        this.sendQuery.type = flag ? 0 : 1;
        api
          .get("/v1/wx/companyScreen/shipDetailList", {
            ...this.sendQuery,
            companyId: this.query.companyId,
            startTime,
            endTime,
          })
          .then((res) => {
            if (res.code === 200) {
              console.log(res.data);
              this.sendList = res.data;
              this.snedTitle = item.text;
              this.sendTotal = res.total;
              this.showSend = true;
            }
          });
      }
    },
    openDailog(tag, type) {
      // console.log("type", type);
      this.tableLoading = true;
      this.query.tag = tag;
      if (type !== undefined) {
        this.query.type = type;
      } else {
        this.query.type = 0;
      }
      this.query.page = 1;
      this.dialogTableVisible = true;
      api.get("/v1/wx/companyScreen/detailList", this.query).then((res) => {
        if (res.code === 200) {
          this.gridData = res.data;
          this.total = res.total;
          this.tableLoading = false;
        }
      });
    },
    pageChange(val) {
      this.tableLoading = true;
      this.query.page = val;
      api.get("/v1/wx/companyScreen/detailList", this.query).then((res) => {
        if (res.code === 200) {
          this.gridData = res.data;
          this.total = res.total;
          this.tableLoading = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$box-width: 100%;
$box-height: 375px;

#centerLeft1 {
  padding-top: 16px;
  height: $box-height;
  width: $box-width;
  border-radius: 10px;
  .bg-color-black {
    height: $box-height;
    border-radius: 10px;
  }
  .text {
    color: #c3cbde;
  }
  .dv-dec-3 {
    position: relative;
    width: 100px;
    height: 20px;
    top: -3px;
  }

  .bottom-data {
    width: 50%;
    .item-box {
      /*margin-top: 40px;*/
      & > div {
        padding-right: 5px;
        display: flex;
        justify-content: center;
      }
      font-size: 16px;
      float: right;
      position: relative;
      width: 50%;
      color: #d3d6dd;

      .dv-digital-flop {
        width: 150px;
        height: 30px;
        font-size: 28px;
        color: #1eb6fe;
      }
      // 金币
      .coin {
        position: relative;
        top: 6px;
        font-size: 20px;
        color: #ffc107;
      }
      .colorYellow {
        color: yellowgreen;
      }
      p {
        text-align: center;
      }
    }
  }
  .bottom-data1 {
    /*width: 100%;*/
    .item-box {
      /*margin-top: 40px;*/
      & > div {
        padding-right: 5px;
        display: flex;
        justify-content: center;
      }
      font-size: 16px;
      float: right;
      position: relative;
      width: 25%;
      color: #d3d6dd;

      .dv-digital-flop {
        width: 150px;
        height: 30px;
        font-size: 28px;
        color: #1eb6fe;
      }
      // 金币
      .coin {
        position: relative;
        top: 6px;
        font-size: 20px;
        color: #ffc107;
      }
      .colorYellow {
        color: yellowgreen;
      }
      p {
        text-align: center;
      }
    }
  }
}
.dv-decoration-3 {
  svg {
    transform: none !important;
  }
}
.df {
  display: flex;
}
.grey {
  color: #909399;
}

.data-grid {
  width: 50%;
  padding-bottom: 40px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 1px 0px;
  grid-template-areas:
    ". ."
    ". .";
}
.data-grid-0 {
  height: 80%;
  padding-bottom: 60px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 1px 0px;
  grid-template-areas:
    ". . . ."
    ". . . .";
}
.jcc {
  justify-content: center;
}
.aic {
  align-items: center;
}
.colorYellow {
  color: yellowgreen;
}
.pointer {
  cursor: pointer;
}
/deep/ .el-dialog__header {
  line-height: 24px !important;
}
/deep/ .el-table__header {
  .el-table__cell {
    line-height: 24px !important;
  }
}
.aic {
  align-items: center;
}
.jcb {
  justify-content: space-between;
}
.demo-table-expand {
  font-size: 0;

  /deep/ .el-form-item__label {
    width: 90px;
    color: #99a9bf;
  }

  /deep/ .el-form-item__content {
    width: 50%;
  }

  /deep/ .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 10%;
  }
}

/deep/.el-range-separator {
  width: 9% !important;
}
</style>
<style lang="scss" >
::v-deep .el-dialog__wrapper {
  z-index: 999999 !important;
}
::v-deep .el-popper {
  z-index: 99999999 !important;
}
</style>

